import {
  Shape,
  Rectangle,
  Text,
  Bitmap,
  Container
} from "@createjs/easeljs";

var rocketMassText;
var heightReachedText;
var maxSpeedText;
var timeText;
var prevHeightText;
var thrustText;
var thrustTimeText;
var forceText;

var rocketMass;
var heightReached;
var maxSpeed;
var time;
var prevHeight;
var thrustset;

var thrustTime;
var force;

var statContainer;

let containerWidth = 180;
let containerHeight = 255;

function formatNumber(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function createStatsModal(params) {
  // create container and border line
  var modal = new Container();

 var bg = new Shape();
 bg.graphics.beginFill("rgba(0,0,0,0.8)").drawRect(0,0,containerWidth,containerHeight);
 modal.addChild(bg);

  var border = new Shape ();
  border.graphics.beginStroke('#44C7F1');
  border.graphics.drawRect(0, 0,containerWidth,containerHeight);
  border.graphics.setStrokeStyle(1, 'round', 'round');
  modal.addChild(border);

  // add the diagonal line images to the top and bottom of container
  var diagLine1 = new Bitmap('../src/images/diag-lines.svg');
  diagLine1.scaleX = 1;
  diagLine1.scaleY = 1;
  diagLine1.x = 10;
  diagLine1.y = 5;
  modal.addChild(diagLine1);

  var diagLine2 = new Bitmap('../src/images/diag-lines.svg');
  diagLine2.scaleX = 1;
  diagLine2.scaleY = 1;
  diagLine2.x = 10;
  diagLine2.y = 225;
  modal.addChild(diagLine2);

  // add the divider to the container
  var divider = new Bitmap('../src/images/stat-divide.svg');
  divider.scaleX = 1;
  divider.scaleY = 1;
  divider.x = 10;
  divider.y = 100;
  modal.addChild(divider);

  statContainer = new Container();
  modal.addChild(statContainer);
  // add the text to the container
  createInfoText(modal, statContainer, params.currentStats, params.rocket);
  modal.alpha = 0;
  return modal;
}


function createInfoText(container, statContainer, stats, rocket) {

  let textX = containerWidth/2-35;
  let textAlign = 'center';
  var yourSettings = createText('YOUR SETTINGS',containerWidth/2,35,'center');
  container.addChild(yourSettings);

  rocketMassText = createText(`Mass:`,textX,50, textAlign);
  container.addChild(rocketMassText);

  thrustText = createText(`Thrust:`, textX,65, textAlign);
  container.addChild(thrustText);

  thrustTimeText = createText(`Thrust time:`,textX,80, textAlign);
  container.addChild(thrustTimeText);

  var rocketStatsText = createText(`ROCKET STATS`,containerWidth/2,130, 'center');
  container.addChild(rocketStatsText);

  maxSpeedText = createText(`Speed:`,textX,145, textAlign);
  container.addChild(maxSpeedText);

  timeText = createText(`Since launch:`,textX,160, textAlign);
  container.addChild(timeText);

  heightReachedText = createText(`Max height:`,textX,175, textAlign);
  container.addChild(heightReachedText);

  forceText = createText(`Force:`,textX,190, textAlign);
  container.addChild(forceText);

  prevHeightText = createText(`Prev height:`,textX,205, textAlign);
  container.addChild(prevHeightText);

  // VALUES FROM HERE

  let newX = containerWidth/2+30;
  rocketMass = createText(`${ formatNumber( Math.round( Number( stats.mass ) ) )} kg`,newX,50, textAlign);
  statContainer.addChild(rocketMass);

  thrustset = createText(`${ formatNumber( Math.round( Number( stats.thrust ) ) )} N`, newX,65, textAlign);
  statContainer.addChild(thrustset);

  thrustTime = createText(`${formatNumber( Math.round( Number( rocket.thrust_time ) ) )} s`,containerWidth/2+40,80, textAlign);
  statContainer.addChild(thrustTime);

  maxSpeed = createText(`${formatNumber( Math.round( Number( stats.speed ) ) )} m/s`,containerWidth/2+30,145, textAlign);
  statContainer.addChild(maxSpeed);

  time = createText(`${formatNumber( Math.round( Number( stats.sinceLaunch ) ) )} s`,containerWidth/2+55,160, textAlign);
  statContainer.addChild(time);

  heightReached = createText(`${formatNumber( Math.round( Number( stats.maxHeight ) ) )} km`,containerWidth/2+40,175, textAlign);
  statContainer.addChild(heightReached);

  force = createText(`${formatNumber( Math.round( Number( stats.force ) ) )} N`,containerWidth/2+30,190, textAlign);
  statContainer.addChild(force);

  prevHeight = createText(`${stats.prevHeight || 'n/a'} KM`,containerWidth/2+50,205, textAlign);
  statContainer.addChild(prevHeight);



}

function createText(text,x,y ,align){
  var temp = new Text(text,"14px Poppins", "#15b9ed");
  temp.x = x;
  temp.y = y;
  temp.textAlign = align;
  return temp;
}

export function updateModal(params){
  let stats = params.currentStats;
  let rocket  = params.rocket;

  if(!stats.explodes){
    heightReached.text = `${formatNumber( Math.round( Number(stats.maxHeight)))} km`;
    maxSpeed.text= `${stats.speed >0 ? formatNumber( Math.round( Number( stats.speed ) ) ) : '0'} m/s`;
    time.text= `${formatNumber( Math.round( Number(stats.sinceLaunch)))} s`;
    prevHeight.text= `${stats.prevHeight || 'n/a'} `;
    if ( stats.prevHeight) {
      var statsprevHeight = stats.prevHeight;
      prevHeight.text= `${ formatNumber( Math.round( Number( stats.prevHeight  ) ) ) } km`;
    }



    rocketMass.text= `${formatNumber( Math.round( Number( stats.mass) ) )} kg`;
    thrust.text= `${formatNumber( Math.round( Number(stats.thrust) ) )} N`;
    thrustTime.text= `${formatNumber( Math.round( Number(rocket.thrust_time) ) )} s`;
    force.text = `${formatNumber( Math.round( Number(stats.force) ) )} N`;
  }


}
